var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as classNames from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/student/Button";
import { Card } from "@components/ui/Card";
import * as s from "./ConcertCard.sss";
export const ConcertCard = (_a) => {
    var { concert, onSubmit, className } = _a, props = __rest(_a, ["concert", "onSubmit", "className"]);
    const { t } = useTranslation();
    const { date, time, title, description, price } = concert;
    return (React.createElement(Card, { className: classNames(s.root, className) },
        React.createElement("span", { className: s.date }, date),
        React.createElement("span", { className: s.time }, time),
        React.createElement("div", { className: s.title }, title),
        React.createElement("div", { className: s.description }, description),
        React.createElement(Button, { theme: "ghostOrange", className: s.button, onClick: onSubmit }, t("site~Придбати"))));
};
export default ConcertCard;
